import React, { useRef } from "react";
import styles from "./LayoutSelector.module.css";
import { connect } from "react-redux";
import {
	primaryTextColor,
	fw500,
	titleL,
	titleXL,
	secondaryTextColor,
} from "./../../../Global.module.css";
import {
	updateActiveSlide,
	updateSlides,
} from "../../../store/actions/updateSlideList";
import { getLayoutImage } from "../getLayoutImage";
import Layout from "../Layout.json";
import { nanoid } from "nanoid";
import { captureSlidePreview } from "../../../helpers/captureSlidePreview";
import { addSlide as api_addSlide } from "../../../helpers/api";
import { UndoRedo } from "../../../helpers/undoRedo";
import { useOutsideClick } from "../../../helpers/useOutsideClick";

const LayoutSelector = (props) => {
	const ref = useRef();

	useOutsideClick(ref, () => {
		props.closeModal();
	});

	const selectLayout = (layoutType) => {
		if (layoutType) addSlide(layoutType, props.insertIndex);
		props.closeModal();
	};

	const addSlide = async (layout, insertIndex) => {
		if (layout) {
			let slides = props.slideList.slides;
			let slide = {
				v: process.env.REACT_APP_EDITOR_VERSION,
				id: nanoid(16),
				data: {},
				preview: "",
				layout,
			};
			if (insertIndex === props.slideList.slides.length) {
				slides.push(slide);
			} else if (insertIndex === 0) {
				slides.unshift(slide);
			} else {
				slides.splice(insertIndex, 0, slide);
			}
			props.updateSlides({ slides });
			props.updateActiveSlide({ activeSlide: insertIndex });
			let preview = await captureSlidePreview(slide.id);
			slide.preview = preview;
			UndoRedo.addSlide(slide, insertIndex);
			UndoRedo.updateActiveSlide(slide);
			try {
				await api_addSlide(props.slidesMetaData.id, slide, insertIndex);
			} catch (error) {}
		}
	};

	const showLayoutImages = () => {
		let layouts = [];
		for (const property in Layout) {
			layouts.push(
				<div className={styles.layout} key={Layout[property]}>
					<img
						src={getLayoutImage(Layout[property])}
						alt="Layout"
						onClick={() => selectLayout(Layout[property])}
						width="200"
						height="200"
					/>
				</div>
			);
		}

		return layouts;
	};

	return (
		<div className={styles.layoutSelector} ref={ref}>
			<div className={styles.header}>
				<p className={`${primaryTextColor} ${fw500} ${titleXL}`}>
					Select Slide Layout
				</p>
				<p
					className={`${secondaryTextColor} ${fw500} ${titleL} ${styles.closeBtn}`}
					onClick={props.closeModal}
				>
					Close
				</p>
			</div>
			<div className={styles.layoutContainer}>{showLayoutImages()}</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	...state,
});
const mapDispatchToProps = (dispatch) => ({
	updateSlides: (payload) => dispatch(updateSlides(payload)),
	updateActiveSlide: (payload) => dispatch(updateActiveSlide(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LayoutSelector);
